import React from 'react';

const Certificate = ({ size }) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width={`${size}px`} height={`${size}px`} viewBox="0 0 204.000000 205.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,205.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M565 1848 c-11 -6 -23 -16 -27 -22 -4 -6 -8 -93 -8 -192 l0 -182 44
            5 c66 8 108 -3 152 -41 21 -18 56 -39 77 -46 55 -18 103 -64 123 -118 10 -26
            32 -64 50 -85 43 -52 59 -111 44 -167 -9 -32 -9 -54 0 -90 15 -63 0 -119 -46
            -169 -18 -21 -34 -46 -34 -55 0 -32 -41 -96 -75 -119 l-35 -22 0 -142 0 -143
            420 0 421 0 24 25 25 24 0 526 0 525 -228 0 c-299 0 -272 -27 -272 273 l0 227
            -317 0 c-218 -1 -324 -4 -338 -12z"/>
            <path d="M1330 1661 l0 -201 196 0 196 0 -6 28 c-8 32 -329 357 -363 367 l-23
            6 0 -200z"/>
            <path d="M405 1351 c-11 -5 -31 -20 -44 -35 -13 -14 -46 -33 -73 -42 -51 -17
            -72 -39 -84 -89 -4 -16 -22 -47 -39 -68 l-32 -37 0 -126 0 -126 33 -39 c18
            -22 36 -56 40 -75 7 -37 53 -84 83 -84 37 0 41 -19 41 -192 0 -92 2 -168 5
            -168 3 0 47 21 98 46 l93 46 92 -46 c50 -25 94 -46 97 -46 3 0 5 79 5 175 l0
            174 41 12 c45 14 65 36 80 92 5 20 23 52 38 70 38 43 44 68 31 117 -8 29 -8
            51 0 81 15 53 8 77 -34 127 -18 23 -36 56 -40 75 -8 41 -40 72 -84 82 -18 4
            -54 25 -79 47 -43 37 -49 39 -87 32 -51 -9 -81 -10 -126 -1 -19 3 -44 3 -55
            -2z m192 -202 c35 -13 90 -64 110 -104 21 -39 21 -131 1 -170 -38 -73 -105
            -115 -183 -115 -221 0 -286 297 -85 384 41 18 117 20 157 5z"/>
            </g>
        </svg>
    );
};

export default Certificate;